import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useWorkflowState = (trackingId: string | undefined) =>
  useQuery({
    queryKey: [{ endpoint: "/api/workflows/:trackingId/", params: { trackingId } }],
    queryFn: async () => await apiClient.getWorkflowState({ params: { trackingId: trackingId! } }),
    enabled: !!trackingId,
  });
